import { NgModule } from '@angular/core';
import { MeDashboardComponent } from './me-dashboard.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MeLoginRoutesModule } from './me-dashboard.routes';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MeSelfReportModule } from '../self-report/me-self-report.module';
import { MePackageModule } from '../packages/me-package.module';
import { MeAppointmentModule } from '../appointment/appointment.module';
import { MeDynamicReportModule } from '../dynamic-report/dynamic-report.module';
import { BannersModule } from '../banners/banners.module';
import { DefaultCardComponent } from './cards/default-card.component';
import { MeDiagnosisPredictionCardComponent } from './cards/diagnosis-prediction/diagnosis-prediction.component';
import { DocumentsCardComponent } from './cards/documents/documents-card.component';
import { DigaCardComponent } from './cards/diga-card/diga-card.component';
import { ArticleCardComponent } from './cards/articles-card/article-card.component';

@NgModule({
    imports: [
        BaseModule,
        MeLoginRoutesModule,
        MePackageModule,
        MeDynamicReportModule,
        MeAppointmentModule,
        StoryBlokLinkModule,
        TabsModule.forRoot(),
        MeSelfReportModule,
        BannersModule
    ],
    declarations: [
        MeDashboardComponent,
        DefaultCardComponent,
        DocumentsCardComponent,
        DigaCardComponent,
        ArticleCardComponent,
        MeDiagnosisPredictionCardComponent
    ],
    exports: [
        MeDashboardComponent
    ]
})
export class MeDashboardModule { }
